import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import BrandCard from '~/components/BrandCard';
import Breadcrumbs from '~/components/breadcrumbs/Breadcrumbs';
import Layout from '~/layouts/Default';
import { BrandsLoaderData } from '~/pages/BrandsPage';

interface BrandsListingProps {
  serverData: BrandsLoaderData;
}

const BrandsListing: React.FC<BrandsListingProps> = ({ serverData }) => {
  const { t } = useTranslation();
  const { brands } = serverData;

  const breadcrumbs = [
    { label: t('common.home'), url: '/' },
    { label: t('brands.title'), url: '' },
  ];

  return (
    <Layout>
      <Container>
        <Breadcrumbs paths={breadcrumbs} />
        <div className="brands-header">
          <h1 className="brands-header__title">{t('brands.title')}</h1>
        </div>

        {brands.length > 0 ? (
          <Row className="brands-grid">
            {brands.map((brand) => (
              <Col key={brand.id} xs={6} sm={4} md={3} lg={2} className="brands-grid__item">
                <BrandCard brand={brand} />
              </Col>
            ))}
          </Row>
        ) : (
          <div className="text-center h3 mt-5">
            <strong>{t('brands.no_brands')}</strong>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default BrandsListing;
